module.exports = __webpack_public_path__ + "img/HQ-DNC-V1_ALL.258e64cb.jpg";